<template>
    <div
        class="modal fade"
        id="subOperationsModal"
        tabindex="-1"
        aria-labelledby="subOperationsModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="subOperationsModalLabel">
                        {{ data.operation_name }}
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="garage-modal">
                        <div class="garage-modal__info">
                            <div class="info__box info__box--full-width">
                                <div class="info__label">Listado de Operaciones</div>
                                <div class="info__content info__content--services">
                                    <ul>
                                        <li
                                            v-for="operation in data.sub_operations"
                                            :key="operation.id"
                                        >
                                            {{ operation.name }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn--outline" data-bs-dismiss="modal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, ref } from 'vue'

const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
    url_get_operations: {
        type: String,
        default: '',
    },
})

const emit = defineEmits(['close-modal'])

const closeModal = () => {
    $('#subOperationsModal').modal('hide')
    emit('close-modal')
}
</script>
